import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import CloseIcon from '@mui/icons-material/Close';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Avatar, Box, Dialog, Fab, List, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import { getInstColor, getUserFullName } from 'app/utils/appHelpers';
import { useEffect, useState } from 'react';
import config from '../../../config';

import RoleUnitDataTable from '../DataTable/RoleUnitDataTable';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

const RoleUserList = ({ userList, handleDeleteUser, title, role }) => {

  const [openUnitDialogStatus, setOpenUnitDialogStatus] = useState(false);
  const [userUnitList, setUserUnitList] = useState();
  const [list, setList] = useState(userList);

  useEffect(() => {
    if (role === 369) {
      const uniqueList = userList.filter((item, index, self) =>
        index === self.findIndex(i => i.id === item.id)
      );
      setList(uniqueList)
    }
  }, [setList])


  const handleUnitClick = async (item) => {
    setOpenUnitDialogStatus(true)
    const uniqueList = userList.filter(x => (x.id === item.id))
    setUserUnitList(uniqueList)
  }

  const handleClose = async () => {
    setOpenUnitDialogStatus(false);
  };

  const columnData = [
    { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
    { id: 'name', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon Adı" },
    { id: 'islemler', align: 'left', disablePadding: true, label: "İşlemler" }
  ];

  const { baseFontSize, fabStyle } = useTemplateFontSettings();

  return (

    < JumboCardQuick
      title={<Typography variant='h6' sx={{ fontSize: baseFontSize }}> {title}
        <Chip label={list.length} size={'small'} sx={{ fontSize: '10px' }} /></Typography >}
      wrapperSx={{
        p: 0,
        height: '463px',
      }}

      headerSx={{ borderBottom: 1, borderBottomColor: 'divider', minHeight: '75px' }}

    >
      <JumboScrollbar
        autoHeight
        autoHeightMin={420}
        autoHide
        autoHideDuration={200}
        autoHideTimeout={500}
      >
        <List disablePadding>
          {list.map((item, index) => (
            <ListItemButton component={"li"} sx={{ paddingRight: '10px', paddingLeft: '10px', borderBottom: 1, borderBottomColor: 'divider' }}>
              <ListItemAvatar>
                <Avatar
                  sx={{ width: fabStyle.width, height: fabStyle.height }}
                  alt={item.name} src={item && item.profileImageUrl ? `${config.userAuthApiUrl}${item.profileImageUrl}` : undefined}
                  onError={(e) => { e.target.onerror = null; e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl }}
                />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant='body1' mb={.5} sx={{ fontSize: baseFontSize, display: 'flex', alignItems: 'center' }}>
                    {getUserFullName(item)}
                    {item.roleInst && (
                      <Chip label={item.roleInst} color={getInstColor(item.roleInst)} size={'small'} sx={{ fontSize: '10px', ml: 1 }} />
                    )}
                  </Typography>
                }
              />
              {<ListItemIcon sx={{ minWidth: 32, ml: 2 }}>
                {role === 369 || role === 372 ? (
                  <Fab
                    sx={{ width: 29, height: 29, minHeight: 29 }}
                    size="small"
                    handleDeleteUser={(item)}
                    onClick={() => {
                      handleUnitClick(item);
                    }}
                  >
                    <FormatListBulletedIcon />
                  </Fab>
                ) : (
                  <Fab
                    sx={{ width: 29, height: 29, minHeight: 29 }}
                    size="small"
                    aria-label="Delete"
                    handleDeleteUser={(item)}
                    onClick={() => {
                      handleDeleteUser(item);
                    }}
                  >
                    <CloseIcon />
                  </Fab>
                )}
              </ListItemIcon>}
            </ListItemButton>
          ))}
        </List>

      </JumboScrollbar>


      {

        <Dialog onClose={handleClose} open={openUnitDialogStatus} maxWidth="sm" fullWidth scroll="paper">

          <RoleUnitDataTable mainData={userUnitList} column={columnData} pageTitle="Kurul/Kol/Komisyon Listesi" handleDeleteUser={handleDeleteUser} setOpenUnitDialogStatus={setOpenUnitDialogStatus} />

        </Dialog >

      }


    </JumboCardQuick >

  );

}

export default RoleUserList;